export default __webpack_public_path__ + "static/media/P945_RoHS.93b0c0ed.pdf";